import {gql} from 'apollo-angular';


export const pdfBulkExportMutation = gql`
  mutation PdfBulkExportMutation ($context: DossierBulkExportContextInput!) {
    bulkDossierExport (context: $context)
  }
`;
